// extracted by mini-css-extract-plugin
export default {"rating":"qK-z","numberOfStars":"rK-z","count":"sK-z","barGraphSpacing":"tK-z","barGraph":"uK-z"};